import React, { createContext, useContext } from "react";
import { getData } from "./Api";

const data = {
  loading: false,
  error: false,
  data: [],
};

const carouselReducer = (state, action) => {
  switch (action.type) {
    case "LOADING":
      return { ...state, loading: true, error: false };
    case "SUCCESS":
      return {
        ...state,
        loading: false,
        error: false,
        data: action.payload,
      };
    case "ERROR":
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
};

const CarouselContext = createContext();

export const CarouselProvider = ({ children }) => {
  const [carouselState, dispatch] = React.useReducer(carouselReducer, data);

  const getCarouselAssets = async () => {
    dispatch({ type: "LOADING" });
    try {
      const urlPath = `/images?type=carousel/`;
      await getData(urlPath).then((data) => {
        if (data?.type === "ERROR") { 
            return dispatch({
            type: "ERROR",
            payload: data.payload
        })}
        return dispatch({
          type: "SUCCESS",
          payload: data.payload?.urls
        });
      });
    } catch (error) {
      return dispatch({
        type: "ERROR",
        payload: error,
      });
    }
  };

  return (
    <CarouselContext.Provider value={{ getCarouselAssets, carouselState }}>
      {children}
    </CarouselContext.Provider>
  );
};

export const useCarousel = () => {
  const context = useContext(CarouselContext);

  if (!context) {
    return new Error("Provider required");
  }
  return context;
};
